import React from 'react';

export default (props) => {
    return (
        <svg viewBox="0 0 60 60" {...props}>
            <path fill="#9698A0"
                  d="M30 58C14.536 58 2 45.464 2 30S14.536 2 30 2s28 12.536 28 28-12.536 28-28 28zM19.267 18.886c-2.322 0-4.2 2.713-4.2 6.067 0 3.348 1.878 6.066 4.2 6.066 2.318 0 4.2-2.718 4.2-6.066 0-3.354-1.882-6.067-4.2-6.067zm21.464 0c-2.319 0-4.2 2.713-4.2 6.067 0 3.348 1.881 6.066 4.2 6.066 2.32 0 4.2-2.718 4.2-6.066 0-3.354-1.88-6.067-4.2-6.067zm1.282 24.18c1.404 0 1.404-3.733 0-3.733H17.985c-1.404 0-1.404 3.734 0 3.734h24.028z"/>
        </svg>
    );
}